import React from 'react';
import type { GetProps } from '@types';
import ToggleButton from '@components/ToggleButton';

type Props = Pick<GetProps<typeof ToggleButton>, 'isOn' | 'onToggle'>;

function MainToggle({ isOn, onToggle }: Props) {
  return (
    <div className="mb-10 flex h-50 items-center justify-between rounded bg-black-#28 px-10">
      <div>启用功能</div>
      <ToggleButton isOn={isOn} onToggle={onToggle} />
    </div>
  );
}

export default MainToggle;
